// @ts-nochec
import { makeStyles } from '@material-ui/core';

export const useSyles = makeStyles({
  datetime: {
    paddingTop: '5px',
    cursor: 'pointer',
  },
  status: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
  expired_message: {},
  tableRow: {},
  boxicon: {
    background: '#979499',
    width: '100px',
    height: '80px',
    padding: '10px 20px',
    borderRadius: '10px',
    '& > p': {
      margin: '-13px -15px 0',
      color: 'white',
      textAlign: 'center',
    },
  },
  title: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    color: '#1d1a20',
    display: 'flex',
    justifyContent: 'center',
  },
  iconActive: {
    background: '#00da69',
  },
  iconClose: {
    background: '#7C01FF',
  },
  icon: {
    width: '60px',
    height: '60px',
    color: 'white',
    marginTop: '-8px',
  },
  info: {
    background: '#EDF7F8',
    color: '#320066',
    fontSize: '22px',
    padding: '16px 26px',
    borderRadius: '8px',
    position: 'relative',
    marginBottom: '7px',
    '& > p': {
      margin: '4px 0',
    },
  },
  close: {
    position: 'absolute',
    top: '6px',
    right: '6px',
    cursor: 'pointer',
    '& > svg': {
      width: '20px',
    },
  },
  boxButtonsKey: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  boxButtons: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    alignContent: ' space-evenly',
    gap: '16px',
  },
  buttonkey: {
    height: 'auto',
    background: '#F8F2FF',
    '& > svg': {
      width: '25px',
      color: '#7C01FF',
    },
    '& > .MuiButton-label': {
      display: 'grid',
      gridTemplateColumns: '25px 125px',
      fontSize: '14px',
      '& > .barcode': {
        fontWeight: 'bold',
        fontSize: '16px',
      },
      '& > .type': {
        gridColumnStart: '1',
        gridColumnEnd: '3',
        fontWeight: 'bold',
        color: '#4A0199',
      },
      '& > .description': {
        gridColumnStart: '1',
        gridColumnEnd: '3',
        textTransform: 'none',
      },
    },
  },
  buttonKeyActive: {
    color: 'white',
    background: 'rgba(124, 1, 255, 0.5)',
    '& > .MuiButton-startIcon': {
      color: '#4A0199',
    },
    '&:hover': {
      color: 'white',
      background: 'rgba(124, 1, 255, 0.5)',
    },
  },
  resume: {
    background: '#EDF7F8',
    padding: '20px',
    borderRadius: '16px',
    margin: 'auto',
    gap: '30px',
  },
  verification: {
    margin: 'auto',
    display: 'flex',
    padding: '0 40px',
    justifycontent: 'center',
    textAlign: 'center',
    fontSize: '26px',
    color: '#320066',
    width: 'fit-content',
  },
});
